import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { SessionDetailPage } from '../../pages/session-detail/session-detail';
import { ModalController, LoadingController, AlertController, Loading, ToastController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { AdminProvider } from '../../providers/admin/admin';
import { WhereFilterOp } from '@firebase/firestore-types';
import { UserUpdateAdminPage } from '../../pages/user-update-admin/user-update-admin';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';

@Component({
  selector: 'user-details',
  templateUrl: 'user-details.html'
})
export class UserDetailsComponent implements OnChanges {
  @Input() public itemSel: any;
  @Input() public isAdmin: any;
  form = { internalComments: '' };
  comments: any[] = [];
  loading: Loading;
  usuarios: any[] = [];
  internalComments: any[] = [];
  coachDoc: AngularFirestoreDocument<any>;
  public myCoach: any;
  commentsCollection: AngularFirestoreCollection<any>;
  public myComments: any[] = [];
  currentUser: string;

  constructor(public sanitizer: DomSanitizer, public admin: AdminProvider, public afAuth: AngularFireAuth, private alertCtrl: AlertController, private asf: AngularFirestore, public modalCtrl: ModalController, public loadingCtrl: LoadingController, private FireAuth: AngularFireAuth, public toastCtrl: ToastController) {

  }

  updateItem(item: any) {
    let modal = this.modalCtrl.create(UserUpdateAdminPage, { "item": item });
    modal.present();
    modal.onDidDismiss(data => {
      if (data) {
        if (data.type == 'updated') {
          this.itemSel = data.data;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.lastComments(changes.itemSel.currentValue.id);
    this.users(changes.itemSel.currentValue.id);
    this.loadComments(changes.itemSel.currentValue.id);
    this.currentUser = changes.itemSel.currentValue.id;
  }

  loadComments(uid: string) {
    this.commentsCollection = this.asf.collection('Users').doc(uid).collection('internalComments', ref => ref.orderBy('date', 'desc'));
    this.commentsCollection.snapshotChanges().subscribe(collection => {
      this.myComments = collection.map(element => {
        const data = element.payload.doc.data();
        const id = element.payload.doc.id;
        return { id, ...data }
      });
    });
  }

  users(uid: string) {
    this.asf.collection("Users").ref.where("type", "==", 2).orderBy("uppercaseName","asc").get().then(collection => {
      if (!collection.empty) {
        this.usuarios = collection.docs.map(element => {
          const data = element.data();
          const id = element.id;
          return { id, ...data }
        });
      }
    }).catch((error) => {
      ////console.error(error);
    });
  }

  ngOnInit() {
  }

  viewItem(item: Promise<any>) {
    item.then(data => {
      let Modal = this.modalCtrl.create(SessionDetailPage, { "item": data });
      Modal.present();
    });
  }

  dateFormatter(date: any) {
    return moment(date).format('L');
  }

  presentPrompt() {
    let alert = this.alertCtrl.create({
      title: 'Agregar comentarios',
      inputs: [
        {
          name: 'comments',
          placeholder: 'Comentarios'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Agregar',
          handler: (data) => {
            this.saveComments(data.comments);
          }
        }
      ]
    });
    alert.present();
  }

  saveComments(comments: string) {
    this.presentLoadingCustom();
    const uid = this.afAuth.auth.currentUser.uid;
    if (comments && uid) {
      this.asf.doc("Users/" + uid).ref.get().then(document => {
        this.asf.collection('Users').doc(this.currentUser).collection('internalComments').add({
          comment: comments, autor: document.data().name, date: new Date()
        }).then(() => {
          this.presentToast("¡Comentario agregado correctamente!");
          this.loading.dismiss();
        }).catch((error) => {
          this.presentToast("¡Ha ocurrido un error!");
          ////console.error(error);
          this.loading.dismiss();
        });
      }).catch((error) => {
        this.presentToast("¡Ha ocurrido un error!");
        ////console.error(error);
        this.loading.dismiss();
      });
    } else {
      this.loading.dismiss();
      this.presentToast("¡Comentario no agregado!");
    }
  }

  saveComments2() {
    if (this.form && this.form.internalComments != '') {
      let loading = this.loadingCtrl.create({});
      this.FireAuth.auth.onAuthStateChanged(data => {
        if (data && data.uid) {
          this.asf.doc("Users/" + data.uid).ref.get().then(document => {
            if (document.exists) {
              loading.present();
              this.comments = [];
              this.comments = this.itemSel && this.itemSel.internalComments ? this.itemSel.internalComments : [];
              this.comments.push({ comment: this.form.internalComments, autor: document.data().name, date: new Date() });
              this.asf.collection("Users").doc(this.itemSel.id).update({ "internalComments": this.comments }).then(() => {
                this.itemSel.internalComments = this.comments;
                this.form.internalComments = '';
                loading.dismiss();
              }).catch((error) => {
                ////console.error(error);;
                loading.dismiss();
              });
            }
          });
        }
      });
    }
  }

  stringDate(_date: any): string {
    return moment(new Date(_date)).format("lll");
  }

  presentConfirmDelete(id: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar usuario',
      message: '¿Estas seguro de eliminar usuario?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id);
          }
        }
      ]
    });
    alert.present();
  }

  async deleteDb(idDocument) {
    const promise1: Promise<any> = this.deleteWhere("Sessions", "idAlumno", "==", idDocument);
    const promise2: Promise<any> = this.deleteWhere("Tasks", "idAlumno", "==", idDocument);
    const promise3: Promise<any> = this.asf.doc("Users/" + idDocument).delete();
    await Promise.all([promise1, promise2, promise3]);
  }

  async deleteWhere(collection: string, field: string, operator: WhereFilterOp, value: any) {
    let query = this.asf.collection(collection).ref.where(field, operator, value).get();
    let batch = this.asf.firestore.batch();
    await query.then(async data => {
      data.docs.forEach(element => {
        batch.delete(element.ref);
      });
      await batch.commit();
    });
  }

  deleteItem(idDocument: string) {
    this.presentLoadingCustom();
    this.afAuth.auth.currentUser.getIdToken(true).then((idToken) => {
      this.admin.deleteAccount(idToken, idDocument).toPromise().then((response) => {
        if (response['success'] == true) {
          this.deleteDb(idDocument).then(() => {
            this.itemSel = {};
            this.loading.dismiss();
            this.presentToast('Eliminado correctamente');
            this.internalComments = [];
          }).catch(error => {
            this.loading.dismiss();
            ////console.error(error);
            this.presentToast('Ha ocurrido un error');
          });
        } else {
          this.loading.dismiss();
          ////console.error(response);
          this.presentToast('Ha ocurrido un error');
        }
      }).catch(error => {
        this.loading.dismiss();
        ////console.error(error);
        this.presentToast('Ha ocurrido un error');
      });
    }).catch(error => {
      this.loading.dismiss();
      ////console.error(error);
      this.presentToast('Ha ocurrido un error');
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  lastComments(id) {
    this.asf.collection('Sessions').ref.where("idAlumno", "==", id).orderBy("sessionDate", "desc").limit(10).get().then(collection => {
      if (!collection.empty) {
        collection.forEach(element => {
          if (element.get('internalComments')) {
            this.internalComments.push(element.data());
          }
        });
      }
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/user-details/user-details.ts